export default () => ({
    list: [],
    total: 0,
    isLoading: false,
    loaded: false,
    groups: [],
    translatedGroups: []
})
